export default "__VITE_ASSET__CLrS2weM__"